"use strict";
// Copyright (C) 2017-2025 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var components_1 = require("stremio/components");
var EpisodePicker_less_1 = __importDefault(require("./EpisodePicker.less"));
var EpisodePicker = function (_a) {
    var className = _a.className, onSubmit = _a.onSubmit;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_1.useMemo)(function () {
        var splitPath = window.location.hash.split('/');
        var videoId = decodeURIComponent(splitPath[splitPath.length - 1]);
        var _a = videoId ? videoId.split(':') : [], pathSeason = _a[1], pathEpisode = _a[2];
        return {
            initialSeason: parseInt(pathSeason) || 0,
            initialEpisode: parseInt(pathEpisode) || 1
        };
    }, []), initialSeason = _b.initialSeason, initialEpisode = _b.initialEpisode;
    var _c = (0, react_1.useState)(initialSeason), season = _c[0], setSeason = _c[1];
    var _d = (0, react_1.useState)(initialEpisode), episode = _d[0], setEpisode = _d[1];
    var handleSeasonChange = (0, react_1.useCallback)(function (event) {
        setSeason(parseInt(event.target.value));
    }, []);
    var handleEpisodeChange = (0, react_1.useCallback)(function (event) {
        setEpisode(parseInt(event.target.value));
    }, []);
    var handleSubmit = function () {
        onSubmit(season, episode);
    };
    var disabled = season === initialSeason && episode === initialEpisode;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(components_1.NumberInput, { min: 0, label: t('SEASON'), defaultValue: season, onChange: handleSeasonChange, showButtons: true }),
        react_1.default.createElement(components_1.NumberInput, { min: 1, label: t('EPISODE'), defaultValue: episode, onChange: handleEpisodeChange, showButtons: true }),
        react_1.default.createElement(components_1.Button, { className: EpisodePicker_less_1.default['button-container'], onClick: handleSubmit, disabled: disabled },
            react_1.default.createElement("div", { className: EpisodePicker_less_1.default['label'] }, t('SIDEBAR_SHOW_STREAMS')))));
};
exports.default = EpisodePicker;
